export default __webpack_public_path__ + "static/media/pvilla6-1.88094e91.jpg";